module.exports = __webpack_public_path__ + "img/1517650198.fc9842fb.jpg";